import 'CssFolder/components/user-badge.scss';
import { staticUrls } from '../../config/constants';

/**
 * 
 * 
 * Example:
 ```
  m(UserBadgeComponent, {
    image: <img-uri>,
    imageSize: '128px',
  }, [
    m('.user-text-lg', <text>),
    m('.user-text-md', <text>),
    m('.user-text-sm', <text>),
  ]),
```
 */
export default function UserBadgeComponent() {
  return {
    view: (vnode) => {
      return m('.schedule-user-info.d-flex',
        {
          class: vnode.attrs.class,
          style: {
            'gap': vnode.attrs.flexGap,
            'flex-wrap': vnode.attrs.flexWrap,
            'flex-direction': vnode.attrs.flexDirection
          }
        },
        m('.user-image-wrapper.flex-shrink-0', { style: {
          width: vnode.attrs.imageSize ? vnode.attrs.imageSize : '64px',
          height: vnode.attrs.imageSize ? vnode.attrs.imageSize : '64px',
        }},
          m('img', {
            src: _.isEmpty(vnode.attrs.image)
              ? staticUrls.emptyUserImage
              : vnode.attrs.image,
          })
        ),
        m('.user-text-info.d-flex.flex-column',
          vnode.children
        ),
      )
    }
  }
}